import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import s from "./tabs-round.module.css";
export function TabsRound(_a) {
    var tabsList = _a.tabsList, onChange = _a.onChange, className = _a.className;
    var _b = useState(0), activeTab = _b[0], setActiveTab = _b[1];
    useEffect(function () { return onChange(tabsList[activeTab]); }, [activeTab]);
    return (React.createElement("div", { className: "".concat(s.tabs, " ").concat(className || '') }, tabsList.map(function (name, index) { return (React.createElement(Tab, { name: name, isActive: activeTab === index, onClick: function () { return setActiveTab(index); }, key: "".concat(name, "-").concat(index) })); })));
}
TabsRound.propTypes = {
    tabsList: propTypes.arrayOf(propTypes.string).isRequired,
    onChange: propTypes.func.isRequired,
    className: propTypes.string
};
function Tab(_a) {
    var name = _a.name, onClick = _a.onClick, isActive = _a.isActive;
    return (React.createElement("button", { onClick: onClick, className: "".concat(s.tab, " ").concat(isActive ? s.active : '') }, name));
}
Tab.propTypes = {
    name: propTypes.string,
    onClick: propTypes.func,
    isActive: propTypes.bool
};
//# sourceMappingURL=TabsRound.js.map